import { Box, Divider, Paper, Typography, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import { congdoan_get_info } from 'components/authentication/actions';
import { loaded, loading } from 'components/mam-non-page/actions';
import { FMI_MONTH_YEAR_FORMAT, FMI_YEAR_MONTH_FORMAT } from 'config/constants/dateConstants';
import dayjs from 'dayjs';
import { messageHelper } from 'helpers/messageHelper';
import usePrevious from 'helpers/usePrevious';
import { get } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { Controller, useForm } from 'react-hook-form';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { useDispatch, useSelector } from 'react-redux';
import { callApiExportMamNonMonthlyReport } from 'redux/saga/mam-non/thu-chi/report/exportMonthlyReport';

function MamNonMonthlyReportPage() {
    const { control, getValues, watch } = useForm();
    const dispatch = useDispatch();
    const userInfo = useSelector((state) => state.authenticationReducer.userInfo, {});
    const congDoanInfo = useSelector((state) => state.commonReducer.congDoanInfo, null);
    const [pdfFile, setPdfFile] = useState(null);
    const [numPages, setNumPages] = useState(null);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const theme = useTheme();

    const watches = watch();
    const values = getValues();
    const prevValues = usePrevious(values);

    const exportMamNonReportPDF = useCallback(() => {
        dispatch(loading());
        callApiExportMamNonMonthlyReport(userInfo.congDoanId, dayjs(values.monthYear).format(FMI_YEAR_MONTH_FORMAT), true)
            .then((res) => {
                const pdfURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
                setPdfFile(pdfURL);
            })
            .catch((err) => {
                messageHelper.showError(err);
            })
            .finally(() => {
                dispatch(loaded());
            });
    }, [dispatch, userInfo.congDoanId, values.monthYear]);

    useEffect(() => {
        const isDiff = JSON.stringify(values) !== JSON.stringify(prevValues);
        if (isDiff && values.monthYear) {
            if (userInfo.congDoanId) {
                setPdfFile(null);
                exportMamNonReportPDF();
            }
        }
    }, [values, watches, prevValues, exportMamNonReportPDF, userInfo.congDoanId]);

    useEffect(() => {
        dispatch(congdoan_get_info());
    }, [dispatch]);

    const onExportReport = () => {
        if (userInfo.congDoanId && values.monthYear) {
            exportMamNonReport();
        }
    };

    const exportMamNonReport = () => {
        dispatch(loading());
        callApiExportMamNonMonthlyReport(userInfo.congDoanId, dayjs(values.monthYear).format(FMI_YEAR_MONTH_FORMAT))
            .then((res) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `Báo cáo mầm non ${get(congDoanInfo, 'congDoanName', '')} tháng ${dayjs(values.monthYear).format(FMI_MONTH_YEAR_FORMAT)}.xlsx`); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
            .catch((err) => {
                messageHelper.showError(err);
            })
            .finally(() => {
                dispatch(loaded());
            });
    };

    return (
        <>
            <Paper elevation={3}>
                <Box p={theme.spacing(0, 3)}>
                    <Typography variant="h6">Báo cáo tháng mầm non</Typography>
                </Box>
                <Divider></Divider>
                <Box p={theme.spacing(1, 1)}>
                    <form>
                        <div className="row m-0">
                            <div className="col-md-3 pr-0">
                                <div className="row mr-0">
                                    <label className="mb-0 col-md-4 fmi-label pr-0" htmlFor="monthYear">
                                        Tháng:
                                    </label>
                                    <div className="col-md-8 p-0">
                                        <Controller
                                            control={control}
                                            id="monthYear"
                                            name="monthYear"
                                            render={(props) => (
                                                <ReactDatePicker
                                                    placeholderText="Chọn tháng"
                                                    onChange={(e) => props.onChange(e)}
                                                    className="form-control chi-mam-non-datepicker"
                                                    dateFormat="MM.yyyy"
                                                    showMonthYearPicker
                                                    locale="vi"
                                                    selected={props.value}
                                                    popperProps={{
                                                        positionFixed: true,
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3"></div>
                            <div className="col-md-3"></div>
                            {watches.monthYear && (
                                <div className="col-md-3">
                                    <div className="row mx-0 w-100">
                                        <button type="button" className={clsx({ 'export-button btn btn-primary mb-1 fmi-toolbar-button': true })} onClick={onExportReport}>
                                            Xuất báo cáo
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </form>
                </Box>
            </Paper>
            {pdfFile && (
                <div className="align-pdf">
                    <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
                        {Array.from(new Array(numPages), (el, index) => (
                            <Page key={index} pageNumber={index + 1}></Page>
                        ))}
                    </Document>
                </div>
            )}
        </>
    );
}

export default MamNonMonthlyReportPage;
